import { c as _c } from "react/compiler-runtime";
import { UseViewPortType, ViewPortType } from "@website/hooks/viewport/viewport.types";
import debounce from "lodash-es/debounce";
import { useEffect, useState } from "react";
let defaultViewport: ViewPortType = "xs";
const map: Record<ViewPortType, number> = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
};
const getViewport = () => (Object.entries(map).reverse().find(view => window.innerWidth >= view[1])?.[0] || "xs") as ViewPortType;
export const useViewPort: UseViewPortType = () => {
  const $ = _c(10);
  const [viewPort, setViewPort] = useState(defaultViewport);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const eventCallback = debounce(() => {
        defaultViewport = getViewport();
        setViewPort(defaultViewport);
      }, 500);
      defaultViewport = getViewport();
      setViewPort(defaultViewport);
      window.addEventListener("resize", eventCallback);
      return () => window.removeEventListener("resize", eventCallback);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["xs", "sm"];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = t2.includes(viewPort);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["md"];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = t4.includes(viewPort);
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["lg", "xl", "2xl"];
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = t6.includes(viewPort);
  let t8;
  if ($[5] !== t3 || $[6] !== t5 || $[7] !== t7 || $[8] !== viewPort) {
    t8 = {
      viewPort,
      isMobile: t3,
      isTablet: t5,
      isDesktop: t7
    };
    $[5] = t3;
    $[6] = t5;
    $[7] = t7;
    $[8] = viewPort;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};